{
  "intro": "Публичные адреса проекта, по которым серверы доступны из интернета. Адрес принадлежит проекту, а не серверу: его можно перенести на другой сервер того же региона и сохранить, даже когда сервер удалён. IPv4 оплачивается каждый месяц, даже не назначенный; IPv6 бесплатен.",
  "empty": "Публичных адресов пока нет",
  "emptyLead": "Адреса появляются вместе с серверами. Создайте адрес заранее, если он должен пережить сервер: например, чтобы не менять DNS-записи при пересоздании.",
  "create": "Создать IP-адрес",
  "createLead": "Новый адрес в регионе или сразу на выключенном сервере.",
  "createSubmit": "Создать адрес",
  "created": "Адрес {{address}} создан",
  "name": "Название",
  "nameHint": "Чтобы узнать адрес в списке, например по сайту, который на нём работает.",
  "family": "Тип",
  "ipv4Price": "{{price}} в месяц. Нужен большинству сервисов.",
  "ipv4Paid": "Оплачивается помесячно.",
  "ipv6Free": "Сеть /64, бесплатно.",
  "where": "Куда",
  "keepFree": "Оставить свободным в регионе",
  "onServer": "Сразу назначить серверу",
  "zone": "Сетевая зона {{zone}}",
  "regionHint": "Адрес можно назначать только серверам этого региона.",
  "server": "Сервер",
  "chooseServer": "Выберите сервер",
  "offOnly": "Hetzner меняет основные адреса только у выключенного сервера. У сервера может быть один IPv4 и один IPv6.",
  "autoDelete": "Удаляется с сервером",
  "autoDeleteLabel": "Удалять вместе с сервером",
  "autoDeleteHint": "Если включено, адрес исчезнет вместе с сервером, которому назначен. Выключите, чтобы сохранить адрес после удаления сервера.",
  "autoDeleteOn": "Удалять вместе с сервером",
  "autoDeleteOff": "Сохранять после удаления сервера",
  "autoDeleteOnDone": "Адрес {{address}} будет удалён вместе с сервером",
  "autoDeleteOffDone": "Адрес {{address}} сохранится после удаления сервера",
  "billing": "IPv4 оплачивается с момента создания и до удаления — назначен он серверу или нет. IPv6 бесплатен. Удалённый адрес вернуть нельзя: следующий будет другим.",
  "address": "Адрес",
  "unassigned": "Свободен",
  "serverOn": "Сервер не выключен",
  "dnsShort": "Обратный DNS",
  "flags": "Свойства",
  "protected": "Защищён",
  "blocked": "Заблокирован",
  "price": "В месяц",
  "free": "Бесплатно",
  "createdAt": "Создан",
  "assign": "Назначить серверу",
  "assignTitle": "Назначить {{address}} серверу",
  "assignLead": "Сервер должен быть выключен и находиться в том же регионе. Изменение займёт несколько секунд.",
  "assigning": "Назначаем {{address}}",
  "unassign": "Снять с сервера",
  "unassigning": "Снимаем {{address}} с сервера",
  "dns": "Обратный DNS",
  "dnsTitle": "Обратный DNS для {{address}}",
  "dnsLead": "Имя, которое возвращает запрос по адресу (PTR-запись). Почтовые серверы проверяют его при приёме писем.",
  "dnsAddress": "Адрес внутри сети",
  "dnsAddressHint": "Любой адрес из {{network}}, например тот, что настроен на сервере.",
  "dnsName": "Имя хоста",
  "dnsNameHint": "Полное имя, например mail.example.com. Прямая запись этого имени должна указывать на этот адрес.",
  "dnsWhy": "Обратный DNS превращает адрес в имя. Без него письма с сервера чаще попадают в спам.",
  "dnsInvalid": "Нужно полное имя хоста, например mail.example.com.",
  "dnsReset": "Вернуть стандартное",
  "dnsChanging": "Меняем обратный DNS для {{address}}",
  "rename": "Переименовать",
  "protect": "Включить защиту от удаления",
  "unprotect": "Снять защиту от удаления",
  "delete": "Удалить",
  "deleteTitle": "Удалить адрес {{address}}?",
  "deleteLost": "Адрес будет потерян навсегда: Hetzner выдаст его кому-то другому, а вам при следующем создании — другой.",
  "deleteDns": "DNS-записи, которые указывают на этот адрес, перестанут работать.",
  "deleteBilling": "Оплата за адрес прекратится.",
  "deleteFree": "IPv6 бесплатен, денег удаление не сэкономит.",
  "deleted": "Адрес {{address}} удалён",
  "why": {
    "assigned": "Уже назначен серверу {{server}}: сначала снимите его.",
    "notAssigned": "Адрес никому не назначен.",
    "serverRunning": "Сервер {{server}} не выключен: Hetzner снимает адрес только с выключенного сервера.",
    "blocked": "Адрес заблокирован провайдером.",
    "protected": "Включена защита от удаления: сначала снимите её.",
    "deleteAssigned": "Адрес назначен серверу: сначала снимите его.",
    "otherRegion": "другой регион",
    "hasAddress": "уже есть {{family}}",
    "running": "не выключен"
  }
}
